module.exports = __webpack_public_path__ + "img/home1.c3683531.jpg";